import { defineStore } from 'pinia';
import type { NavigationNode } from '../../types/link';
import { watch, ref } from 'vue';
import { useStoreAllNavs } from './allNavs';

export type StoreMainNav = {
  items?: NavigationNode[];
};

const storeId = 'store-main-nav';

export const useStoreMainNavigation = defineStore(storeId, () => {
  const storeAllNavs = useStoreAllNavs();
  const items = ref<StoreMainNav['items']>();

  async function fetchItems() {
    if (!storeAllNavs.allNavs?.mainNav) {
      console.error(`${storeId} >>> error`, 'allNavsStore is not available');
      return;
    }

    const navItems = new Array(storeAllNavs.allNavs.mainNav);

    if (navItems) {
      items.value = navItems;
    }
  }

  watch(storeAllNavs, () => {
    if (storeAllNavs.allNavs && !items.value) {
      fetchItems();
    }
  });

  return {
    items,
  };
});
